import styled, { css } from 'styled-components'
import { colors, sizes } from 'config/ui'

const openAnim = `
  max-height: 600px;
  border: solid 1px ${colors.lightGray};
  box-shadow: 0 5px 5px 0 rgba(0,0,0,.1);
`
const closeAnim = `
  max-height: 0px;
  border: 0 none;
  box-shadow: 0 5px 5px 0 rgba(0,0,0,0);
`

export const StyledAutocomplete = styled.div`
  ${({ visible }) => css`
    z-index: 10;
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 1px;
    overflow: hidden;
    background-color: ${colors.white};
    transition: all 250ms ease;
    ${visible ? openAnim : closeAnim} border-radius: 3px;
  `};
`

export const Item = styled.div`
  color: ${colors.darkGray};
  padding: 10px;
  cursor: pointer;
  transition: color ease 200ms;
  border-bottom: solid 1px ${colors.lightGray};
  font-size: ${sizes.smallText}px;

  &:last-child {
    border-bottom: 0 none;
  }

  &:hover {
    color: ${colors.black};
  }
`

export const Highlight = styled.span`
  color: ${colors.black};
  font-weight: 900;
`

export const SecondLine = styled.div`
  color: ${colors.gray};
`

export const Superscript = styled.div`
  font-size: ${sizes.smallText - 2}px;
  opacity: 0.6;
  margin-bottom: 2px;
`
